import { MdFormatQuote } from 'react-icons/md';
import { t } from '../../utils/i18n';

const SECONDARY = ['t2', 't3'];

function initials(name) {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();
}

export default function TestimonialsSection() {
  return (
    <section className="landing-section landing-section--testimonials">
      <div className="landing-container">
        <div className="landing-testimonials-split">
          <header className="landing-testimonials-intro">
            <h2 className="landing-section-title">{t('landing.testimonials.title')}</h2>
            <p className="landing-section-subtitle">{t('landing.testimonials.subtitle')}</p>
          </header>

          <div className="landing-testimonials-cards">
            <TestimonialCard id="t1" featured />
            <div className="landing-testimonials-secondary">
              {SECONDARY.map((id) => (
                <TestimonialCard key={id} id={id} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function TestimonialCard({ id, featured = false }) {
  const prefix = `landing.testimonials.${id}`;
  const name = t(`${prefix}.name`);
  return (
    <blockquote
      className={`landing-testimonial-card ${featured ? 'landing-testimonial-card--featured' : ''}`}
    >
      <MdFormatQuote className="landing-testimonial-mark" aria-hidden="true" />
      <p className="landing-testimonial-text">{t(`${prefix}.text`)}</p>
      <footer className="landing-testimonial-footer">
        <span className="landing-testimonial-avatar" aria-hidden="true">
          {initials(name)}
        </span>
        <cite className="landing-testimonial-author not-italic">
          {name}, {t(`${prefix}.role`)}
        </cite>
      </footer>
    </blockquote>
  );
}
